var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveBankAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30524_31952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61535 17.2602V8.31641H16.8078V17.2446C16.8078 17.3071 16.8078 17.3696 16.8078 17.4243C16.8078 17.5102 16.8232 17.5805 16.716 17.5805C15.9428 17.5805 15.1773 17.5805 14.4042 17.5805H3.42679C3.18182 17.5805 2.94452 17.5805 2.69955 17.5805C2.59238 17.5805 2.61535 17.5258 2.61535 17.4321V17.2681V17.2602Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3466 7.01949V7.98295C18.3466 8.16824 18.1782 8.31646 17.9791 8.31646H1.56666C1.35998 8.31646 1.19922 8.16824 1.19922 7.98295V7.01949C1.19922 6.90091 1.26811 6.79715 1.37529 6.73786L9.58152 2.05393C9.704 1.98723 9.8571 1.98723 9.97193 2.05393L18.1782 6.73786C18.2853 6.79715 18.3542 6.90832 18.3542 7.01949H18.3466Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8392 17.5713H0.998047",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 8.33203V17.5181",
    stroke: "#3876BB",
    strokeWidth: 1.10778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 8.33203V17.5181",
    stroke: "#3876BB",
    strokeWidth: 1.10778
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5153 20H11.4847C10.3887 20 9.5 19.1113 9.5 18.0153V11.9847C9.5 10.8887 10.3887 10 11.4847 10H17.5153C18.6113 10 19.5 10.8887 19.5 11.9847V18.0153C19.5 19.1113 18.6113 20 17.5153 20Z",
    fill: "#ECF1F7",
    stroke: "#F7C0C0",
    strokeWidth: 0.681798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3688 13.1348L12.6328 16.8703",
    stroke: "#FF7A7A",
    strokeWidth: 0.709571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3688 16.8703L12.6328 13.1348",
    stroke: "#FF7A7A",
    strokeWidth: 0.709571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30524_31952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBankAccountIcon);
export default __webpack_public_path__ + "static/media/RemoveBankAccountIcon.abb4da65f11f9482c2c1853abfba6145.svg";
export { ForwardRef as ReactComponent };